import {Grid, Paper, Container, Card} from '@material-ui/core';
import React, {useContext, useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {cities} from './utils/Constants';
import {ViewContext} from './contexts/ViewContext';
import Chart from './Chart';

const useStyles = makeStyles((theme) => ({
	paper: {
		marginTop: theme.spacing(3),
		marginBottom: theme.spacing(3),
	},
}));

export default function Dashboard() {
	const {view} = useContext(ViewContext);

	const classes = useStyles();
	const [chartsData, setChartsdata] = useState([]);

	// SELECT CITY
	useEffect(() => {
		const thisCity = cities.find((city) => city.name === view.selectedCity);
		setChartsdata(thisCity.chartsData);
	}, [view.selectedCity]);

	return (
		<div className="dashboard">
			<Container className={classes.paper}>
				<Grid container spacing={3}>
					{chartsData && chartsData.map((data) => <Chart key={data.title} chartdata={data} />)}
				</Grid>
			</Container>
		</div>
	);
}
